import ReactGA from 'react-ga4'
import { getConsent, subscribeConsent } from '@storybrandhq/gtm-cookie-consent'

let gaInitialized = false

const analyticsAllowed = () => getConsent('analytics_storage')

const ensureGaInit = () => {
  if (gaInitialized) return
  gaInitialized = true
  ReactGA.initialize(process.env.REACT_APP_GA_ID)
}

// Send a GA4 pageview once analytics_storage consent is granted. Consent resolves
// asynchronously after page load (the appConsentUpdate event arrives once GTM
// loads), so if it hasn't resolved yet we wait for the first consent update and
// then send — otherwise a returning, already-consented visitor would lose their
// landing pageview to the race.
export const trackPageviewWithConsent = () => {
  if (!process.env.REACT_APP_GA_ID) return () => {}

  let sent = false
  const trySend = () => {
    if (sent || !analyticsAllowed()) return
    ensureGaInit()
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: document.title })
    sent = true
  }

  trySend()
  if (sent) return () => {}

  return subscribeConsent(() => trySend())
}
